/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sla_DurationInputs */

const vi_sla_duration = /** @type {(inputs: Sla_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời hạn (phút)`)
};

/**

* @param {Sla_DurationInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sla_duration = /** @type {((inputs?: Sla_DurationInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sla_DurationInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sla_duration(inputs)
});